module.exports = __webpack_public_path__ + "static/img/block-5.c65a325b.png";